// eslint-disable-next-line
const { __ } = wp.i18n;

class GoogleMap {
  constructor(element) {
    this.element = element;
    this.settings = this.element.querySelector('[data-element="settings"]');
    this.input = this.element.querySelector('.wpgmza-address.addressInput');
    this.search = this.element.querySelector('input.wpgmza-search');
    this.reset = this.element.querySelector('input.wpgmza-reset');
    this.listing = this.element.querySelector('.wpgmza-marker-grid');
    this.error = this.element.querySelector('.wpgmza-no-results');
  }

  init() {
    this.modifyInput();
    this.input.addEventListener('input', this.onInputChange.bind(this));
    this.search.addEventListener('click', this.onSearchClick.bind(this));
    this.reset.addEventListener('click', this.onResetClick.bind(this));
    this.listing.setAttribute('data-reset', false);
    this.listingObserver = new MutationObserver(this.callbackElementObserver.bind(this));
    this.listingObserver.observe(this.listing, {subtree: true, childList: true});
    this.setRoleToError();
    this.cloneErrorForEmptyInput();
    this.onFilteringComplete();
  }

  modifyInput() {
    this.input.placeholder = this.settings.dataset.inputPlaceholder;
    this.resetIcon = document.createElement('button');
    this.resetIcon.ariaLabel = this.settings.dataset.resetLabel;
    this.resetIcon.className = 'wpgmza-reset-icon';
    this.input.after(this.resetIcon);
    this.resetIcon.addEventListener('click', () => {
      this.reset.click();
    });
  }

  onInputChange() {
    if (this.input.value === '') {
      this.resetIcon.classList.remove('show');
    } else {
      this.resetIcon.classList.add('show');
    }
  }

  cloneErrorForEmptyInput() {
    this.errorEmpty = this.error.cloneNode(true);
    this.errorEmpty.querySelector('p[data-name="notFoundMessage"]').innerText = 'Enter a city, state, or ZIP code';
    this.errorEmpty.id = 'noInputValueError';
    this.error.after(this.errorEmpty);
  }

  onSearchClick() {
    this.listing.setAttribute('data-reset', false);
    this.validateInput();
  }

  onResetClick() {
    this.removeErrors();
    this.input.value = '';
    this.resetIcon.classList.remove('show');
    this.listing.setAttribute('data-reset', true);
    this.listing.classList.remove('show');

    if (this.pagination !== null) {
      this.pagination.classList.remove('show');
    }
  }

  setRoleToError() {
    this.error.setAttribute('role', 'status');
  }

  validateInput() {
    this.removeErrors();

    if (this.input.value === '') {
      this.input.parentNode.classList.add('error');
      this.errorEmpty.style.display = 'block';
    }
  }

  removeErrors() {
    this.input.parentNode.classList.remove('error');
  }

  callbackElementObserver(mutationList) {
    if (this.listing.dataset.reset === 'false' && mutationList[0].removedNodes.length > 0) {
      this.listing.setAttribute('data-reset', false);

      if (this.getNumberofItemsInListing() > 0) {
        this.listing.classList.add('show');
      }

      this.setListingElements();
      this.setPaginationElements();
    }
  }

  getNumberofItemsInListing() {
    return this.listing.childNodes.length;
  }

  setListingElements() {
    this.listingItems = this.element.querySelectorAll('.wpgmaps_mlist_row');
    if (this.listingItems && this.listingItems.length > 0) {
      this.listingItems.forEach((item) => {
        item.addEventListener('click', function(event) {
          event.stopPropagation();
        });
      });
    }
  }

  setPaginationElements() {
    this.paginationPrev = this.element.querySelector('.paginationjs-prev');
    this.paginationNext = this.element.querySelector('.paginationjs-next');
    this.pagination = this.element.querySelector('.wpgmza-pagination');

    if (this.paginationPrev !== null && this.paginationNext !== null) {
      this.paginationPrev.addEventListener('click', this.scrollToElement.bind(this));
      this.paginationNext.addEventListener('click', this.scrollToElement.bind(this));
    }

    if (this.pagination !== null) {
      this.pagination.classList.add('show');
    }
  }

  scrollToElement(event) {
    setTimeout(() => {
      this.element.scrollIntoView({
        behavior: 'smooth',
      });
    }, 800);
  }

  onFilteringComplete() {
    const mainInput = this.input;
    const mainError = this.error;

    /* eslint-disable */
    WPGMZA.StoreLocator.prototype.onFilteringComplete = function(event) {
      const params = event.filteringParams;
      const marker = this.marker;

      if (marker) {
        marker.setVisible(false);
      }


      // Center point marker
      if (params.center) {
        this.map.setCenter(params.center);

        if (marker) {
          marker.setPosition(params.center);
          marker.setVisible(true);

          if (marker.map != this.map) {
            this.map.addMarker(marker);
          }
        }
      }

      // Set zoom level
      if (params.radius) {
        this.map.setZoom(this.getZoomFromRadius(params.radius));
      }

      // Display circle
      const circle = this.circle;

      if (circle) {
        circle.setVisible(false);

        const factor = (this.distanceUnits == WPGMZA.Distance.MILES ? WPGMZA.Distance.KILOMETERS_PER_MILE : 1.0);

        if (params.center && params.radius) {
          circle.setRadius(params.radius * factor);
          circle.setCenter(params.center);
          circle.setVisible(true);

          if (!(circle instanceof WPGMZA.ModernStoreLocatorCircle) && circle.map != this.map) {
            this.map.addCircle(circle);
          }
        }

        if (circle instanceof WPGMZA.ModernStoreLocatorCircle) {
          circle.settings.radiusString = this.radius;
        }
      }

      if (event.filteredMarkers.length == 0) {
        mainError.style.display = 'block';
        mainInput.parentNode.classList.add('error');
      }
    }
    /* eslint-enable */
  }
}

const googleMaps = {
  init() {
    const maps = document.querySelectorAll('[data-module="google-map"]');

    if (maps && maps.length > 0) {
      /* eslint-disable */
      if (WPGMZA === 'undefined' || WPGMZA === null) {
        return false;
      }
      /* eslint-enable */

      maps.forEach((item) => {
        const googleMapItem = new GoogleMap(item);
        googleMapItem.init();
      });
    }
  },
};

export default googleMaps;
